import { useEffect, useState } from 'react'

import { useFormInputContext } from '../contexts/FormInputContext'

export const useKeyboardInsetV2 = () => {
  const { focusedInputUuid, isSomeInputMounted } = useFormInputContext()
  const [bottomInset, setBottomInset] = useState<number>(0)

  useEffect(() => {
    const visualViewport = window.visualViewport

    // If there is no visual viewport or no input is mounted, reset the bottom inset
    if (!visualViewport || !isSomeInputMounted) {
      setBottomInset(0)
      return
    }

    const listener = () => {
      const clientHeight = document.documentElement.clientHeight
      setBottomInset(
        focusedInputUuid && clientHeight
          ? Math.max(
              Math.round(
                clientHeight - visualViewport.height - visualViewport.offsetTop
              ),
              0
            )
          : 0
      )
    }

    visualViewport.addEventListener('resize', listener)
    visualViewport.addEventListener('scroll', listener)

    return () => {
      visualViewport.removeEventListener('resize', listener)
      visualViewport.removeEventListener('scroll', listener)
    }
  }, [focusedInputUuid, isSomeInputMounted])

  return { bottomInset, focusedInputUuid }
}
